import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { mq } from "../../Theme";
import { mapColor } from "../textUtils";
var secondaryText = function(param) {
    var textColor = param.textColor, theme = param.theme;
    return /*#__PURE__*/ css("font-size:0.875rem;line-height:1.429em;", mq("lg"), "{font-size:0.938rem;line-height:1.467em;font-weight:600;}color:", mapColor(theme, textColor), ";");
};
var SecondaryTextWrapper = /*#__PURE__*/ styled("p", {
    target: "e1am9zju0"
})(function(param) {
    var theme = param.theme, textColor = param.textColor;
    return secondaryText({
        theme: theme,
        textColor: textColor
    });
});
var InlineSecondaryTextWrapper = /*#__PURE__*/ styled("span", {
    target: "e1am9zju1"
})(function(param) {
    var theme = param.theme, textColor = param.textColor;
    return secondaryText({
        theme: theme,
        textColor: textColor
    });
});
export { secondaryText, SecondaryTextWrapper, InlineSecondaryTextWrapper };
